'use client'
import { ErrorFallback } from '../error'
import { HDSPlusButton } from '@hashicorp/react-mds/src/hds-plus/button'
import s from './style.module.css'
import type { CareerListing } from 'lib/careers/types'
import {
	GreenhouseQuestionField,
	DataComplianceField,
	EducationQuestionField,
} from './components'
import { useApplicationForm } from 'lib/careers/context'

export interface MDSFormProps {
	career: CareerListing
}

export function MDSForm({ career }: MDSFormProps) {
	const { formState, submitForm } = useApplicationForm()
	const isMidSubmission =
		formState.submissionStatus === 'pending' ||
		formState.submissionStatus === 'success'
	const hasLocationQuestions =
		!!career.location_questions && career.location_questions.length > 0

	const buttonText = isMidSubmission ? 'Please wait' : 'Submit'

	if (formState.submissionStatus === 'error') {
		return <ErrorFallback />
	}

	return (
		<form
			className={s.mdsForm}
			onSubmit={(e) => {
				e.preventDefault()
				submitForm(e)
			}}
			noValidate
		>
			{career.questions.map((question, i) => (
				<GreenhouseQuestionField
					key={i}
					question={question}
					questionType="standard"
				/>
			))}
			{career.hashi_edu_questions.map((question) => (
				<EducationQuestionField key={question.id} question={question} />
			))}
			{hasLocationQuestions &&
				career.location_questions.map((question, i) => {
					return (
						<GreenhouseQuestionField
							key={i}
							question={question}
							questionType="location"
						/>
					)
				})}
			{career.demographic_questions && (
				<section>
					<h2 className={s.demographicQuestionsHeader}>
						{career.demographic_questions.header}
					</h2>
					<div
						dangerouslySetInnerHTML={{
							__html: career.demographic_questions.description,
						}}
					/>
					<div className={s.demographicQuestions}>
						{career.demographic_questions.questions.map((question, i) => {
							return (
								<GreenhouseQuestionField
									key={i}
									question={question}
									questionType="demographic"
								/>
							)
						})}
					</div>
				</section>
			)}
			<DataComplianceField compliance={career.data_compliance[0]} />
			<HDSPlusButton
				data-testid="submit-application-btn"
				disabled={isMidSubmission}
				type="submit"
				size="large"
				text={buttonText}
			/>
		</form>
	)
}
